module.exports = __webpack_public_path__ + "img/7.c70a2bda.png";